import messages from 'dicts/messages';
import services from 'services';
import {getResponseData} from 'utils/app';
import {describeThrow} from 'utils/errors';
import * as normalize from 'utils/normalize';

let httpJson = null;
services.waitFor('api').then(x => (httpJson = x.httpJson));
let intl = null;
services.waitFor('intl').then(x => (intl = x));

export const getLists = (q = {}) =>
	httpJson('get', `/lists`, q)
		.catch(describeThrow(intl.formatMessage({id: messages.contentFetchFailed})))
		.then(getResponseData(normalize.list));
